import { UIHeading4, UIText2, UIText3, useDeviceType } from '@cian/ui-kit';
import { ArrowL16 } from '@cian/ui-kit/prev';
import * as React from 'react';

import * as styles from './styles.css';
import { EDeviceType } from '../../../types/deviceType';

type TChatHeaderUser = {
  isIframe: boolean;
  companionName?: string | null;
  companionIdStr?: string | null;
  companionTypeName?: string | null;
  companionStatus?: string | null;
  callButtonNode: React.ReactNode | null;
  chatMenuNode: React.ReactNode | null;
  userCardButtonNode: React.ReactNode | null;
  handleClickBack: () => void;
  handleClickName: () => void;
};

export const ChatHeaderUser: React.VFC<TChatHeaderUser> = ({
  isIframe,
  companionName,
  companionIdStr,
  companionTypeName,
  companionStatus,
  callButtonNode,
  chatMenuNode,
  userCardButtonNode,
  handleClickBack,
  handleClickName,
}) => {
  const device = useDeviceType();
  const isMobile = device !== EDeviceType.Desktop;

  return (
    <div className={styles['container']} data-testid="chat_header_user">
      {isMobile && !isIframe && (
        <button className={styles['back_button']} onClick={handleClickBack} data-testid="back_button">
          <ArrowL16 color="primary_100" />
        </button>
      )}
      <div className={styles['companion']}>
        <div className={styles['title']} data-testid="chat_header_title">
          <UIHeading4 onClick={handleClickName}>{companionName || companionTypeName}</UIHeading4>
          {!companionName && companionIdStr && <UIText2 color="gray60_100">{`(${companionIdStr})`}</UIText2>}
          {userCardButtonNode}
        </div>
        <div className={styles['status']}>
          <UIText3 color="black_60">{companionStatus}</UIText3>
        </div>
      </div>
      <div className={styles['action_buttons']}>
        {callButtonNode}
        {chatMenuNode}
      </div>
    </div>
  );
};
